import React from "react";
import { useEmailHistory } from "./useEmailHistory";
import EmailHistoryTable from "./EmailHistoryTable";
import "./EmailHistory.css";

/** Status filters offered above the table. */
const STATUS_FILTERS = [
  { value: "", label: "All" },
  { value: "sent", label: "Sent" },
  { value: "pending", label: "Pending" },
  { value: "failed", label: "Failed" },
];

/**
 * Email history page — every send the reminder engine has queued, with its
 * delivery outcome. Read-only: it reports what happened rather than changing it.
 * @returns {JSX.Element}
 */
export default function EmailHistory() {
  const { rows, pagination, status, setStatus, loading, error, load } =
    useEmailHistory();

  return (
    <div className="ehs-root">
      <header className="ehs-header">
        <p className="ehs-muted">
          Every reminder the system has queued, and whether it reached the
          recipient.
        </p>
      </header>

      <section className="ehs-panel">
        <div className="ehs-filters">
          {STATUS_FILTERS.map((f) => (
            <button
              key={f.value || "all"}
              type="button"
              className={`ehs-chip ${status === f.value ? "ehs-chip-active" : ""}`}
              onClick={() => setStatus(f.value)}
            >
              {f.label}
            </button>
          ))}
        </div>

        {error && (
          <div className="ehs-error" role="alert">
            {error}
          </div>
        )}

        {loading ? (
          <p className="ehs-muted">Loading…</p>
        ) : (
          <EmailHistoryTable rows={rows} />
        )}

        {pagination && pagination.total > 0 && (
          <div className="ehs-pagination">
            <button
              type="button"
              className="ehs-btn"
              disabled={pagination.page <= 1 || loading}
              onClick={() => load(pagination.page - 1)}
            >
              Prev
            </button>
            <span className="ehs-muted">
              Page {pagination.page} of {pagination.totalPages} ·{" "}
              {pagination.total} sends
            </span>
            <button
              type="button"
              className="ehs-btn"
              disabled={pagination.page >= pagination.totalPages || loading}
              onClick={() => load(pagination.page + 1)}
            >
              Next
            </button>
          </div>
        )}
      </section>
    </div>
  );
}
